<form [formGroup]="poUploadForm">
  <div class="mb-po-upload-form">
  <div class="mb-po-upload-col">
    <!-- HEADER SECTION -->
    <div class="row no-gutters">
      <div class="col-12 text-center">
        <h3 class="font-weight-bolder" [innerHTML]="'poUploadHeadline.title' | cxTranslate | safeHtml"></h3>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 my-3 text-center">
        <span [innerHTML]="'poUploadHeadline.heading1' | cxTranslate | safeHtml"></span>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 mb-5 text-center">
        <span [innerHTML]="'poUploadHeadline.heading2' | cxTranslate | safeHtml"></span>
      </div>
    </div>
    <!-- END OF HEADER SECTION -->

    <!-- FORM SECTION -->
    <div class="row no-gutters">
      <div class="col-12 po-upload-name-form-margin-right field-wrapper text-sm-left mb-input-margin-bottom"
           mbFloatingLabel
           data-cy="mb-first-name">
        <label for="firstName"
               [ngClass]="['mandatory-input-asterisk mb-custom-label']">
          {{ 'poUploadForm.firstName' | cxTranslate }}
        </label>
        <input class="w-100 mb-form-input"
               id="firstName"
               name="firstName"
               formControlName="firstName"
               data-cy="mb-first-name-input"
               type="text"
               required/>
        <mb-form-errors [control]="poUploadForm?.get(constants.FIRST_NAME_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>

      <div class="col-12 field-wrapper text-sm-left mb-input-margin-bottom"
           mbFloatingLabel
           data-cy="mb-last-name">
        <label for="lastName"
               [ngClass]="['mandatory-input-asterisk mb-custom-label']">
          {{ 'poUploadForm.lastName' | cxTranslate }}
        </label>
        <input class="w-100 mb-form-input"
               id="lastName"
               name="lastName"
               formControlName="lastName"
               data-cy="mb-last-name-input"
               type="text"
               required/>
        <mb-form-errors [control]="poUploadForm?.get(constants.LAST_NAME_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 field-wrapper mb-input-margin-bottom"
           mbFloatingLabel
           data-cy="mb-email">
        <label for="email"
               [ngClass]="['mandatory-input-asterisk mb-custom-label']">
          {{ 'poUploadForm.businessEmail' | cxTranslate }}
        </label>
        <input class="w-100 mb-form-input"
               type="email"
               id="email"
               name="email"
               formControlName="email"
               data-cy="mb-email-input"
               required/>
        <mb-form-errors [control]="poUploadForm?.get(constants.EMAIL_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 field-wrapper mb-input-margin-bottom"
           mbFloatingLabel
           data-cy="mb-phone">
        <label for="phoneNumber"
               [ngClass]="['mandatory-input-asterisk mb-custom-label']">
          {{ 'poUploadForm.phoneNo' | cxTranslate }}
        </label>
        <input class="w-100 mb-form-input"
               type="text"
               id="phoneNumber"
               name="phoneNumber"
               formControlName="phoneNumber"
               data-cy="mb-phone-input"
               required/>
        <mb-form-errors [control]="poUploadForm?.get(constants.PHONE_NUMBER_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 mb-input-margin-bottom">
        <span class="po-upload-file-label">{{ 'poUploadForm.uploadFile' | cxTranslate }}</span>
        <input class="d-block mt-3"
               type="file"
               accept=".pdf"
               size=""
               id="poFile"
               name="poFile"
               formControlName="poFile"
               data-cy="mb-po-file"
               (change)="uploadFile($event)"
               required>
        <mb-form-errors [control]="poUploadForm?.get(constants.PO_FILE_CODE)"
                        [prefix]="'formValidationErrors'">
        </mb-form-errors>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 po-upload-terms-of-use mb-input-margin-bottom">
        <div data-cy="po-upload-terms-of-use">
          <label class="m-0 mb-terms-label"
                 for="termsOfUse">
            <input type="checkbox"
                   formControlName="termsOfUse"
                   id="termsOfUse">
            <span class="mb-label">
              {{'poUploadForm.termsOfUse' | cxTranslate}}
              <a class="mb-terms-link"
                 href="https://www.miltenyibiotec.com/privacy-statement.html"
                 target="_blank"><span>{{'poUploadForm.privacyStatement' | cxTranslate}}</span></a>
            </span>
          </label>
          <mb-form-errors [control]="poUploadForm?.get(constants.TERMS_OF_USE)"
                          [prefix]="'formValidationErrors'">
          </mb-form-errors>
        </div>
      </div>
    </div>
    <!-- END OF FORM SECTION -->

    <!-- SUBMIT SECTION -->
    <div class="row no-gutters">
      <div class="col-12">
        <button mbOneClickAllowed
                class="btn btn-lg mb-btn-primary po-upload-submit-btn"
                [disabled]="poUploadForm.invalid"
                (click)="submitPurchaseOrder()">
          <span [innerHTML]="'poUploadForm.submit' | cxTranslate | safeHtml"></span>
        </button>
      </div>
    </div>
    <!-- END OF SUBMIT SECTION -->
  </div>
  </div>
</form>
